import {
  audienceConfirmationWasCaptured,
  audiencePreferencesSuppressClarity,
} from './audiencePreferences'
import {
  enableAggregateAnalytics,
  enableAnalyticsProviders,
  setAnalyticsContext,
  trackEvent,
  trackPageView,
} from './analytics'
import { readAnalyticsConsent } from './analyticsConsent'
import type { PublicRouteState } from './publicRoute'

export function initializeDocumentAnalytics(
  route: PublicRouteState | null,
  pageType: 'atlas' | 'municipality_profile' | 'municipality_indicator' | 'content',
  trackPageViewImmediately: boolean,
) {
  enableAggregateAnalytics()
  setAnalyticsContext({
    locale: route?.locale,
    pageType,
    routeKind: route?.pageType === 'embed' ? 'atlas' : (route?.pageType ?? 'semantic'),
    metricId: route?.selection.metricId,
    measureId: route?.selection.measureId,
    geographyLevel: route?.selection.level,
    period: route?.selection.period,
    municipalityCode: route?.selectedCode,
    hasSelectedArea: Boolean(route?.selectedCode),
  })
  if (trackPageViewImmediately) trackPageView()
  if (readAnalyticsConsent()?.decision === 'granted') {
    enableAnalyticsProviders({ suppressClarity: audiencePreferencesSuppressClarity() })
    if (audienceConfirmationWasCaptured()) trackEvent('subscription_confirmation')
  }
}

export function initializeStaticDocument(route: PublicRouteState | null) {
  const semanticKind = route?.semanticKind
  const pageType = semanticKind === 'municipality_profile'
    ? 'municipality_profile'
    : semanticKind === 'municipality_indicator'
      ? 'municipality_indicator'
      : 'content'
  initializeDocumentAnalytics(route, pageType, true)
  return route
}
